import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AccesoService } from '../acceso/acceso.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class RiesgoService {
  Respuesta:boolean;
  top10K:any;
  adqScore:any;
  provScore:any;
  rucAdq:any;

  readonly urlBase =  environment.rutaBase;


  constructor( private http: HttpClient , private accesoService :AccesoService) { }

  riesgoRUC(data: any) {
    let headers = this.accesoService.desencriptarTOKEN();


    return this.http.post(
      `http://localhost:8006/riesgo/ruc`,data,{headers});
  }


  obtenerScore(data: any) {
    let headers = this.accesoService.desencriptarTOKEN();
    //let headers :  HttpHeaders = new HttpHeaders();
    //headers =  headers.append('Accept', 'application/json');
    //headers =  headers.append('Authorization', `CNMZZ4jg24QMtNhh`);

    return this.http.post(`${this.urlBase}/Score?id_Empresa=1`,data,{headers});
  }

  obtenerRanking(RUC_ADQ){
    let headers = this.accesoService.desencriptarTOKEN();

    return this.http.get(`${this.urlBase}/Top10K?idEmpresa_Factor=9&Num_Doc_Identificacion_ADQ=${RUC_ADQ}`,{headers})

  }

  // riesgoDNI(data: any) {

  //   let headers :  HttpHeaders = new HttpHeaders();
  //   headers =  headers.append('Accept', 'application/json');
  //   headers =  headers.append('Authorization', 'SrvRiesgoINNOVA');

  //   return this.http.post(
  //     "https://api-riesgos-dev.appspot.com/ObtenerDNI",data,{headers});
  // }

}
